import {HitHtmlUtils} from '@hit/components/src/utils/hit/HitHtmlUtils';
import {BaseAttribute, BaseAttributeOptions} from './BaseAttribute';

export type RichTextAttributeOptions = BaseAttributeOptions;

// Attribute for rich text (HTML) values.
export class RichTextAttribute extends BaseAttribute {
  constructor(options: RichTextAttributeOptions = {}) {
    super(options);
  }

  // Input type that is used if attribute is used in edit mode
  get inputType(): string {
    return 'richtext';
  }

  /**
   * Keeps HTML only when the rich text contains visible content.
   * Returns two values:
   * - The value sent to the database
   * - The value to update the data in the UI
   */
  toDbValue(value: unknown): [unknown, unknown] {
    if (typeof value !== 'string') {
      return [null, null];
    }
    const parsedValue = HitHtmlUtils.htmlHasContent(value) ? value : null;
    return [parsedValue, parsedValue];
  }
}
